export const getFeishuOAuthRedirectUri = () => {
  const supabaseUrl = String(import.meta.env.VITE_SUPABASE_URL || "").replace(
    /\/$/,
    "",
  );
  return supabaseUrl ? `${supabaseUrl}/functions/v1/feishu-oauth-callback` : "";
};

export const getDingTalkOAuthRedirectUri = () => {
  const configuredRedirectUri = String(
    import.meta.env.VITE_DINGTALK_OAUTH_REDIRECT_URI || "",
  ).trim();
  if (configuredRedirectUri) return configuredRedirectUri;
  const supabaseUrl = String(import.meta.env.VITE_SUPABASE_URL || "").replace(
    /\/$/,
    "",
  );
  return supabaseUrl
    ? `${supabaseUrl}/functions/v1/dingtalk-oauth-callback`
    : "";
};
